import {React, DomeManipulator} from '@lexriver/dome'
import cssAnimations from '../Animation.m.scss'
import appCss from '../App.m.scss'
import css from './PopupAsync.m.scss'
import { LoadingSpinnerForButton } from '../components/LoadingSpinnerForButton'
import { DataTypes } from '@lexriver/data-types'
import { Button } from '../components/form/Button'

export module PopupAsync{
    let divOverlay:HTMLDivElement
    let divPopup:HTMLDivElement
    let divContentContainer:HTMLDivElement

    let escapeHandler = (e) => {
        //console.log('escapeHandler', e)
        if(e.key === 'Escape'){
            closePopup()
        }
    }
    
    export async function showPopupAsync(getContent:()=>Promise<HTMLElement|string>|HTMLElement|string){
        //console.log('PopupAsync.showPopup')
        divOverlay = <div class={appCss.blackOverlay}></div>
        document.body.appendChild(divOverlay)
        document.addEventListener('keyup', escapeHandler)
    
        divPopup = (
            <div class={css.popupContainer} >
                <div class={css.popup} ref={ref => divContentContainer = ref}>
                    <div class={css.loadingSpinnerContainer}>
                        <LoadingSpinnerForButton />
                    </div>
                </div>
            </div>
        )
        
        divOverlay.appendChild(divPopup)
        divPopup.classList.add(cssAnimations.zoomIn)
        await loadContentAsync(getContent)
    }

    async function loadContentAsync(getContent:()=>Promise<HTMLElement|string>|HTMLElement|string){
        // console.log('PopupAsync.loadContentAsync')
        const el = await getContent()
        if(DataTypes.isString(el)){
            await DomeManipulator.replaceAllChildrenAsync(divContentContainer, <div class={css.textContainer}>{el}</div>)
        } else {
            await DomeManipulator.replaceAllChildrenAsync(divContentContainer, el)
        }
        await DomeManipulator.appendChildAsync(divContentContainer, <div class={css.buttonContainer}><Button onClick={() => closePopup()} text="OK"/></div>)
        
    }
    
    function closePopup(){
        document.removeEventListener('keyup', escapeHandler)
        divPopup.classList.remove(cssAnimations.zoomIn)
        divPopup.classList.add(cssAnimations.zoomOut)
        setTimeout(() => {
            divOverlay.remove()
        }, 300)

    }
    
}